
import React, {
  // PropTypes
} from 'react';

import {
  // Button,
  Grid, Row, Col,
  Panel
} from 'react-bootstrap';

import Header from './Header';
import NextSectionButton from '../common/NextSectionButton';

import { ux } from '../../app_data/index';
import servicesGenerator from './services';

import './index.css';

const services = servicesGenerator(ux.maxColumnsPerRow);

const Services = () => (
  <div id="services">
    <h3 className="classBecauseCannotIsolateFromPanelH3">
      <NextSectionButton
        targetID="brand"
        angleIcon="up"
        title="Back to top"
      />
      {' '}Services{' '}
      <NextSectionButton
        targetID="stacks"
        title="Programming Languages and Tech Stacks"
      />
      <hr />
    </h3>

    <Grid>
      {
        services.list.map((row, ix) => (
          <Row key={ix}>
            {
              row.map((service, ixix) => (
                <Col
                  key={ixix}
                  md={services.uxColumnWidthPerItem}
                  sm={services.uxColumnWidthPerItem}
                >
                  <Panel header={<Header service={service} />}>
                    {service.description}

                    { /*
                    <hr />
                    Tools: {service.tools}

                    <hr style={ { visibility: 'hidden' } } />
                    <Button
                      bsStyle="info"
                      bsSize="small"
                      onClick={() => {}}
                    >
                      More info
                    </Button>
                    */ }
                  </Panel>
                </Col>
              ))
            }
          </Row>
        ))
      }
    </Grid>
  </div>
);

// Services.propTypes = {
//   services: PropTypes.shape().isRequired
// };

export default Services;



// WEBPACK FOOTER //
// ./src/components/services/index.js